/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import restClient from './restClient';

const RESOURCE_ROOT_CARTSERVICE = '/checkout';
const RESOURCE_VERSION_CARTSERVICE = '/v2';
const RESOURCE_PAGE_CARTSERVICE = '/cart';
const RESOURCE_PAGE_PAYMENT_ROUTE_CARTSERVICE = '/payment';
const RESOURCE_PAGE_GIFT_ROUTE_CARTSERVICE = '/giftcard';

/**
 * giftCard
 * url - /checkout/{apiversion}/cart/payment/{cartId}/giftcard?brand={brandId}
 *
 * @param {Object} args
 * @param {Object} args.env
 * @param {String} args.jwtToken
 * @param {String} args.cartId
 * @param {String} args.account
 * @param {String} args.securityCode
 */
const giftCard = ({
    env, jwtToken, cartId, account, securityCode, recaptcha, recaptchaV2,
}) => {
    const envObj = env || {};

    envObj.rootUri = `${RESOURCE_ROOT_CARTSERVICE}${RESOURCE_VERSION_CARTSERVICE}`;

    const resourcePage =  `${RESOURCE_PAGE_CARTSERVICE}${RESOURCE_PAGE_PAYMENT_ROUTE_CARTSERVICE}/${cartId}${RESOURCE_PAGE_GIFT_ROUTE_CARTSERVICE}`;

    const payload = {
        account,
        securityCode,
    };

    if (recaptcha) {
        if (recaptchaV2) {
            return restClient.postRequest(env, resourcePage, jwtToken, payload, {}, { recaptcha, RecapVerified: recaptchaV2 })
                .then((response) => response);
        }
        return restClient.postRequest(env, resourcePage, jwtToken, payload, {}, { recaptcha })
            .then((response) => response);
    }

    return restClient.postRequest(envObj, resourcePage, jwtToken, payload)
        .then((response) => response);
};

export default giftCard;
